import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-bug1",
  "use": "icon-bug1-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-bug1\"><defs><style type=\"text/css\"></style></defs><path d=\"M960 320h-153.6c-32-70.4-83.2-121.6-153.6-160L768 51.2l-44.8-51.2-140.8 134.4C563.2 134.4 537.6 128 512 128s-51.2 6.4-70.4 6.4L300.8 0 256 51.2l115.2 115.2C300.8 198.4 249.6 249.6 217.6 320H64v64h134.4c-6.4 19.2-6.4 44.8-6.4 64v64H64v64h128v64c0 19.2 0 44.8 6.4 64H64v64h153.6c51.2 115.2 166.4 192 294.4 192s243.2-76.8 294.4-192H960v-64h-134.4c6.4-19.2 6.4-44.8 6.4-64V576h128V512h-128V448c0-19.2 0-44.8-6.4-64H960V320z m-320 384H384V576h256v128z m0-192H384V384h256v128z\" p-id=\"3498\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/bug1.svg
// module id = wsc3
// module chunks = 25